<template>
  <div class="interaction-step">
    <div class="interaction-step__header">
      <div class="interaction-step__header-row">
        <h3 v-if="title" class="interaction-step__title">
          {{ title }}
        </h3>
        <!--<template v-if="showHint">
          <button type="button"
                  class="interaction-step__tip-btn btn-gradient d-sm-none"
                  @click="showTip = !showTip"
                  :class="{'_active': showTip}"
          >

            <template v-if="!showTip">
              <BaseSvg name="ico-question-2"/>
              <span>{{ $tInteraction('Show tips') }}</span>
            </template>

            <template v-else>
              <BaseSvg name="ico-close"/>
              <span>{{ $tInteraction('Hide tips') }}</span>
            </template>

          </button>
          <button type="button"
                  class="interaction-step__tip-btn btn-gradient d-none d-sm-inline-flex"
                  @click="showTip = !showTip"
                  :class="{'_active': showTip}"
          >
            <BaseSvg name="ico-question-2"/>
            <span>{{ $tInteraction('Show tips') }}</span>
          </button>
        </template>-->
      </div>
      <button type="button"
              v-if="showHint"
              class="interaction-step__tip-btn"
              @click="onShowTip"
              :class="{'_active': showTip}"
      >
        <BaseSvg name="ico-help"/>
        <span>{{ $tInteraction('Show tips') }}</span>
      </button>
      <!--<collapse-transition>
        <div v-if="showHint && showTip"
             ref="tipBlock"
             class="interaction-step__tip tip-collapse"
        >

          <div class="tip-collapse__content">
            <button type="button"
                    class="tip-collapse__close d-none d-sm-inline-flex"
                    @click="showTip = !showTip"
                    :class="{'_active': showTip}"
            >
              <BaseSvg name="ico-close"/>
            </button>
            <slot name="tip">
              <div v-if="hint"
                   class="tip-collapse__content-inner">
                <h3 v-if="hint.title"
                    class="tip-collapse__title">{{hint.title}}</h3>
                <div v-if="hint.hint"
                     v-html="hint.hint"
                     class="tip-collapse__text text">
                </div>
              </div>
              <picture v-if="hint.image"
                       class="tip-collapse__image">
                <img :src="hint.image"
                     :alt="$tInteraction('tip')">
              </picture>
            </slot>
          </div>
        </div>
      </collapse-transition>-->
    </div>

    <div class="interaction-step__content-wrap">
      <div class="interaction-step__content">
        <div class="interaction-step__content-inner">
          <slot name="content"/>
        </div>
      </div>
      <div v-if="hasNext"
           class="interaction-step__footer"
           :class="{_waiting: waiting}"
      >

        <button v-if="disabledNext || pendingNext"
                type="button"
                class="interaction-step__next-btn  base-btn  base-btn--green  _disabled">
          <span class="base-btn__text">{{ $tInteraction('Next') }}</span>
          <BaseSvg name="ico-arrow-light"
                   width="0.6rem"
                   height="1rem"/>
          <BasePreloader v-if="pendingNext"/>
        </button>

        <button v-else
                type="button"
                class="interaction-step__next-btn  base-btn  base-btn--green"
                @click.prevent="onNext">
          <span class="base-btn__text">{{ $tInteraction('Next') }}</span>
          <BaseSvg name="ico-arrow-light"
                   width="0.6rem"
                   height="1rem"/>
        </button>

      </div>
    </div>

    <transition name="fade">
      <div v-if="showHint && showTip" class="popup-full _tip">
        <div class="popup-full__wrap" v-click-out="onCloseTip">
          <button type="button"
                  @click.prevent="onCloseTip"
                  class="popup-full__close">
            <BaseSvg name="ico-close"/>
          </button>
          <div class="popup-full__scroll">
            <div class="popup-full__content">
              <h3 class="popup-full__title _top" v-if="hint.title">{{ hint.title }}</h3>
              <div class="popup-full__media" v-if="hint.image">
                <picture class="popup-full__img">
                  <img :src="hint.image"
                       :alt="hint.title">
                </picture>
              </div>
              <div class="popup-full__text text" v-if="hint.hint" v-html="hint.hint"></div>
              <SwitchCheckbox
                  :value="showHintDefault"
                  :label="$tInteraction('Enable hints')"
                  @input="showHintDefaultChange"
                  class="_blue"/>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  // import {eventBus} from '../../main'
  import {mapState, mapActions} from 'vuex'
  import SwitchCheckbox from '@/components/SwitchCheckbox'
  // import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: 'InteractionStep',
    props: {
      disabledNext: {
        type: Boolean,
        default: true
      },
      pendingNext: {
        type: Boolean,
        default: false
      },
      hasNext: {
        type: Boolean,
        default: true
      },
      waiting: {
        type: Boolean,
        default: false
      }
    },
    components: {
      SwitchCheckbox
      // CollapseTransition
    },
    data(vm) {
      return {
        showTip: vm.$store.state.interaction.showHintDefault
      }
    },
    computed: {
      ...mapState('interaction', [
        'title',
        'pendingNextStep',
        'hint',
        'showHintDefault'
      ]),
      showHint() {
        const hint = this.hint
        return !!(hint && (hint.hint || hint.title || hint.image) || this.$slots.tip)
      },
      pending() {
        return this.$store.state.interaction1.pending
      }
    },
    methods: {
      ...mapActions('interaction', [
        'showHintDefaultChange'
      ]),
      onNext() {
        let offset = window.innerWidth > 767 ? -30 : -60
        this.$scrollTo('#interaction-content', {
          offset
        })
        this.$emit('next')
        // eventBus.$emit('onNextEvent')
      },
      // checkTip() {
      //   if (this.showTip && window.innerWidth < 768) {
      //     let tip = this.$refs.tipBlock
      //     if (!tip) return
      //     if (tip.getBoundingClientRect().y + tip.clientHeight < 20) {
      //       this.showTip = false
      //     }
      //   }
      // },
      onShowTip() {
        this.showTip = true
        // this.$vModal.open('interaction-tip', {
        //   hint: this.hint
        // })
      },
      onCloseTip() {
        this.showTip = false
      },
    },
    mounted() {
      // window.addEventListener('scroll', this.checkTip)
    },
    // beforeDestroy() {
    //   window.removeEventListener('scroll', this.checkTip)
    // }
  }
</script>

<style>

</style>
